import { AppError } from './app-error.model';

export enum ConflictErrorType {
  None = '',
  Driver = 'DRIVER',
  User = 'USER',
}
export class ConflictError extends AppError {
  type: ConflictErrorType = ConflictErrorType.None;
  id: number;
}
